<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">商家名称</span>
        <el-input class="w200" maxlength="30" style="width:200px;" v-model="name" placeholder="请输入商家名称"></el-input>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">时间顺序</span>
        <el-select v-model="sortType">
          <div v-for="item in sortTypeList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">开通时间</span>
        <el-date-picker
          v-model="orderTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">快速查询</span>
        <el-select v-model="deadline">
          <div v-for="item in deadlineList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">到期查询</span>
        <el-select v-model="endDateType">
          <div v-for="item in endDateTypeList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <span class="condition-label">销售人员</span>
        <el-select v-model="seller">
          <div v-for="item in sellerList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="getImgList">筛选</el-button>
      </div>
      <div class="condition-wrap">
        <el-button type="success" @click="btnAdd">新增入驻商家</el-button>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" size="middle" row-key="designId" border stripe>
      <el-table-column prop="id" label="ID" align="center" width="50"></el-table-column>
      <el-table-column prop="name" label="商家名称" align="center" width="100"></el-table-column>
      <el-table-column prop="annualFee" label="年费（￥）" align="center" width="130"></el-table-column>
      <el-table-column prop="startDate" label="开通时间" align="center" width="100"></el-table-column>
      <el-table-column prop="endDate" label="到期时间" align="center" width="100"></el-table-column>
      <el-table-column prop="entryFee" label="入驻费（￥）" align="center" width="130"></el-table-column>
      <el-table-column prop="entryFeeDiscount" label="入驻费折扣（%）" align="center" width="150"></el-table-column>
      <el-table-column prop="actualEntryFee" label="实际入驻费（￥）" align="center" width="150"></el-table-column>
      <el-table-column prop="yearLimit" label="年限（年）" align="center" width="100"></el-table-column>
      <el-table-column prop="totalFee" label="总计（￥）" align="center" width="100"></el-table-column>
      <!-- <el-table-column label="状态" align="center" width="140">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="small" type="primary" plain @click="btnEdit(scope.row.id)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="currentChange"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog @close="diaglogClose" :title="isEdit ? '编辑商家' : '新增入驻商家'" :close-on-click-modal="false" :visible.sync="showAddPop" width="500px">
      <el-form :model="addForm" size="small" label-width="100px">
        <el-form-item label="商家名称">
          <el-input v-model="addForm.name" maxlength="30" placeholder="请输入商家名称"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="addForm.operator" maxlength="30" placeholder="请输入联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="addForm.telephone" maxlength="30" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="年费">
          <el-input v-model="addForm.annualFee" readonly placeholder="请输入年费">
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>
        <el-form-item label="缴费年限">
          <el-select v-model="addForm.yearLimit" @change="setendDate">
          <div v-for="item in yearList" :key="item.value">
            <el-option :label="item.name" :value="item.value"></el-option>
          </div>
        </el-select>
        </el-form-item>
        <el-form-item label="开通时间">
          <el-date-picker
            v-model="addForm.startDate"
            @change="setendDate"
            :clearable="false"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            readonly
            v-model="addForm.endDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="入驻费">
          <el-input class="w200" style="width:200px;" type="number" @change="computedPrice" v-model="addForm.entryFee" placeholder="请输入入驻费">
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>
        <el-form-item label="折扣">
          <el-input class="w200" style="width:200px;" type="number" @change="computedPrice" v-model="addForm.entryFeeDiscount" placeholder="请输入折扣">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="实际入驻费">
          <el-input class="w200" style="width:200px;" readonly v-model="addForm.actualEntryFee" placeholder="请输入入驻费">
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>
        <el-form-item label="总费用">
          <el-input class="w200" style="width:200px;" readonly v-model="addForm.totalFee" placeholder="请输入入驻费">
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>
        <el-form-item label="公司logo">
          <el-upload
            class="upload-demo"
            :action="ossUrl"
            :data="addForm.ossDataImg"
            :limit="1"
            :on-success="uploaded"
            :on-change="uploadCg"
            list-type="picture"
            :file-list="addForm.companyLogoKeyList"
            accept="image/png"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">仅支持png, 小于20M</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="销售方">
          <el-select v-model="addForm.seller" placeholder="请选择">
            <el-option label="官方销售" value="1"></el-option>
            <el-option label="第三方销售" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="IP浏览范围">
          <template>
            <el-radio v-model="addForm.ipRange" label="1">全部</el-radio>
            <el-radio v-model="addForm.ipRange" label="2">自有IP</el-radio>
          </template>
        </el-form-item>
        <el-form-item label="介绍">
          <el-input
            type="textarea"
            :rows="3"
            maxlength="100"
            placeholder="请输入商家介绍"
            show-word-limit
            v-model="addForm.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="showAddPop = false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>
import API from "../lib/API";
import {dataTypeList, countryList} from '../lib/constObj.js'
import dayjs from 'dayjs'
let ENTRY_FEE = 50000;
export default {
  name: "OrderList",
  data() {
    return {
      tableData: [],
      name: '',
      orderTime: '',
      endDateType: '1',
      sortTypeList: [
        {
          name: '正序',
          value: 'asc'
        },
        {
          name: '倒序',
          value: 'desc'
        },
      ],
      endDateTypeList: [
        {
          name: '全部',
          value: '1'
        },
        {
          name: '即将到期',
          value: '2'
        },
        {
          name: '已到期',
          value: '3'
        },
      ],
      sortType: '',
      deadlineList: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '一周内到期',
          value: 7
        },
        {
          name: '15天内到期',
          value: 15
        },
        {
          name: '30天内到期',
          value: 30
        },
      ],
      deadline: '',
      sellerList: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '官方',
          value: '1'
        },
        {
          name: '品牌商',
          value: '2'
        },
      ],
      yearList: [
        {
          name: '1',
          value: '1'
        },
        {
          name: '2',
          value: '2'
        },
        {
          name: '3',
          value: '3'
        },
        {
          name: '4',
          value: '4'
        },
        {
          name: '5',
          value: '5'
        },
        {
          name: '6',
          value: '6'
        },
        {
          name: '7',
          value: '7'
        },
        {
          name: '8',
          value: '8'
        },
        {
          name: '9',
          value: '9'
        },
        {
          name: '10',
          value: '10'
        },
      ],
      seller: '',
      content: '',
      categoryId: '',
      pageNum: 1,
      totalPage: 0,
      showAddPop: false,
      ossUrl: '',
      isBrand: true,
      shopId: '',
      categoryLoading: false,
      ossData: {},
      addForm: {
        companyLogoKey: "",
        ossDataImg: {},
        companyLogoKeyList: [],
        name: '',
        yearLimit: '1',
        operator: '',
        annualFee: '15000',
        remark: '',
        startDate: new Date(),
        endDate: '',
        entryFee: ENTRY_FEE,
        entryFeeDiscount: 100,
        actualEntryFee: '',
        totalFee: '',
        seller: "1",
        ipRange: '1',
        status: 1
      },
      countryList: countryList,
      dataTypeList: dataTypeList,
      categoryList: [],
      countryType: '1',
      dataType: '1',
      countryObj: {},
      dataTypeObj: {},
      isEdit: false,
      addCountryList: [],

    };
  },
  mounted () {
    this.setendDate()
    this.computedPrice()
  },
  computed: {
    categoryDisabled() {
      if (this.dataType === '1' || (this.dataType === '2' && this.shopId)) {
        return false
      }
      return true
    },
    categoryDisabledAdd() {
      if (this.addForm.dataType === '1' || (this.addForm.dataType === '2' && this.addForm.shopId)) {
        return false
      }
      return true
    }
  },
  methods: {
    computedPrice() {
      if (this.addForm.entryFeeDiscount < 0 || this.addForm.entryFeeDiscount == '') this.addForm.entryFeeDiscount = 100
      this.addForm.actualEntryFee = Number(this.addForm.entryFee) * this.addForm.entryFeeDiscount / 100
      this.addForm.totalFee = this.addForm.actualEntryFee + Number(this.addForm.annualFee)
    },
    setendDate() {
      if(!this.addForm.startDate) {
        this.addForm.endDate = null
        return
      }
      let year = this.addForm.startDate.getFullYear()
      let month = this.addForm.startDate.getMonth()
      let date = this.addForm.startDate.getDate()
      this.addForm.endDate = new Date(year + Number(this.addForm.yearLimit), month, date)
    },
    btnAdd() {
      this.isEdit = false
      this.showAddPop = true;
      this.ossUrl = "";
      this.ossData = {};
      this.getOss()
    },
    btnEdit(id) {
      this.btnAdd()
      this.isEdit = true;
      new API(this).POST({
        url: "/company/getCompanyDetail?id=" + id,
        cb: res => {
          Object.assign(this.addForm, res)
          if (res.companyLogoKey) {
            this.addForm.companyLogoKeyList = [{name:this.getFileName(res.companyLogoKey), url: res.companyLogoUrl }] 
          } else {
            this.addForm.companyLogoKeyList = []
          }
        }
      });
    },
    getFileName (str) {
      return str.split('/').pop()
    },
    getOss() {
      new API(this).POST({
        url: "/oss/getSignature",
        params: {
          count: 1,
          type: 5
        },
        cb: res => {
          this.ossUrl = res.url;
          this.ossData = JSON.parse(JSON.stringify(res.signatures[0]));
          this.addForm.ossDataImg = JSON.parse(JSON.stringify(res.signatures[0]));
        }
      });
    },
    diaglogClose() {
      this.addForm = {
        companyLogoKey: "",
        ossDataImg: {},
        companyLogoKeyList: [],
        name: '',
        yearLimit: '1',
        operator: '',
        annualFee: '15000',
        remark: '',
        startDate: new Date(),
        endDate: '',
        entryFee: ENTRY_FEE,
        entryFeeDiscount: 100,
        actualEntryFee: '',
        totalFee: '',
        seller: "1",
        ipRange: '1',
        status: 1
      }
      this.setendDate()
      this.computedPrice()
    },
    currentChange(val) {
      this.pageNum = val;
      this.getImgList()
    },
    getImgList() {
      let startDateBegin = ''
      let startDateEnd = ''
      let endDateBegin = ''
      let endDateEnd = ''
      if (this.orderTime) {
        startDateBegin = dayjs(this.orderTime[0]).format('YYYY-MM-DD')
        startDateEnd = dayjs(this.orderTime[1]).format('YYYY-MM-DD')
      }
      if (this.deadline) {
        endDateBegin = dayjs().format('YYYY-MM-DD')
        endDateEnd = this.getEndDateEnd(this.deadline)
      }
      new API(this).POST({
        url: "/company/listWithPage",
        params: {
          name: this.name,
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          seller: this.seller,
          startDateBegin,
          startDateEnd,
          endDateBegin,
          endDateEnd,
          sortType: this.sortType,
          endDateType: this.endDateType
        },
        cb: res => {
          let { pages, result } = res;

          this.totalPage = pages;
          this.tableData = result;
        }
      });
    },
    getEndDateEnd (deadline) {
      return dayjs().add(deadline, 'day').format('YYYY-MM-DD')
    },
    add() {
      let {name, operator, telephone, startDate, companyLogoKey, endDate, entryFee } = this.addForm;
      if (!name) {
        this.$message.error("请填写商家名称~");
        return;
      }
      if (entryFee < ENTRY_FEE) {
        this.$message.error(`入驻费不能小于${ENTRY_FEE}~`);
        return;
      }
      if (!operator) {
        this.$message.error("请填写联系人~");
        return;
      }
      if(telephone && !/^1\d{10}$/.test(telephone)) {
        this.$message.error("请填写正确的联系电话~");
        return;
      }
      if (!startDate) {
        this.$message.error("请选择开通时间~");
        return;
      }
      if (!companyLogoKey) {
        this.$message.error("请上传商家logo~");
        return;
      }
      startDate = dayjs(startDate).format('YYYY-MM-DD')
      endDate = dayjs(endDate).format('YYYY-MM-DD')
      let url = this.isEdit ? '/company/updateCompany' : '/company/addCompany'
      delete this.addForm.categoryName
      new API(this).POST({
        url,
        params: {
          ...this.addForm,
          startDate,
          endDate
        },
        cb: res => {
          if (res === null) {
            this.getImgList();
            this.showAddPop = false;
          }
        }
      });
    },
    uploaded(val) {
      this.addForm.companyLogoKey = this.addForm.ossDataImg.key;
    },
    uploadCg(file) {
      this.uploadCgDeal(file, 'ossDataImg')
    },
    uploadCgDeal(file, attr) {
      let ext = file.raw.type;
      ext = ext ? "." + ext.split("/")[1] : "";
      if (ext.includes('msword')) {
        ext = '.doc'
      } else if (ext.includes('vnd.openxmlformats-officedocument.wordprocessingml.document')) {
        ext = '.docx'
      }
      let hasExt = this.ossData.key.indexOf(".");
      if (hasExt === -1) {
        this.addForm[attr]['key'] = this.ossData.key + ext;
      } else {
        this.addForm[attr]['key'] = this.ossData.key.slice(0, hasExt);
        this.addForm[attr]['key'] += ext;
      }
    },
    dealObj () {
      this.dataTypeList.forEach(item => {
        this.dataTypeObj[item.value] = item.name
      })
      this.countryList.forEach(item => {
        this.countryObj[item.value] = item.name
      })
    }
  },
  created() {
    this.isBrand = localStorage.getItem('roleId') === '4'
    if (this.isBrand) {
      this.shopId = localStorage.getItem('shopId')
      this.dataType = '2'
    }
    this.getImgList()
  }
};
</script>
<style scoped>
  .tagList {
    margin-top:10px;
  }
  .tagList /deep/ .el-tag {
    margin-right: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/SettleManager.vue